var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ticket-flow-lib", {
    attrs: {
      "application-id": _vm.deTicketApplications.FINANZAS,
      "case-type-options": _vm.itemSubTypes,
      email: _vm.email,
      "get-case-modules-service": _vm.getCaseModulesService,
      "get-ticket-catalogues": _vm.getTicketCatalogues,
      "get-user-case-reference-number-types-service":
        _vm.getUserCaseReferenceNumberTypesService,
      "get-user-case-screens-service": _vm.getUserCaseScreensService,
      "save-user-case-service": _vm.saveUserCaseService,
      "validate-reference-number-service": _vm.validateReferenceNumberService
    },
    on: { close: _vm.handleClose }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }